<app-content>
  <app-breadcrumbs>
    <li>
      eUsterka / Zgłoszenie
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      eUsterka / Zgłoszenie
    </h2>
    @if (authed) {
      <form novalidate [formGroup]="form">
        <app-e-application-form [form]="form">
        </app-e-application-form>
      </form>
      <div class='application-actions'>
        <button
          [disabled]="pending"
          type='button'
          class='btn btn-secondary'
          routerLink="/">
        <span>
          Anuluj
        </span>
        </button>
        <button
          [disabled]="pending"
          type='button'
          class='btn btn-primary'
          (click)='onSubmit()'>
          <span>Wyślij</span>
        </button>
      </div>
    } @else {
      <app-alert [closable]="false">
        Zgłaszanie usterek i innych zgłoszeń jest dostępne <strong>wyłącznie dla użytkowników zalogowanych</strong>. Po zalogowaniu uzyskasz możliwość dodania własnego zgłoszenia.
      </app-alert>
    }
  </section>
</app-content>
